import { t } from 'i18n';
import React, { useState } from 'react';
import { styled, Modal, ModalFooter, ModalHeader } from '@teko/ui';
import { Cart } from 'components/desktop/pages';
import { CartLineList } from 'components/desktop/organisms';
import { Button } from '@teko/ecommerce/mobile';
import { useCart } from 'contexts';
import { ConsultationServiceFee } from '@teko/ui-cart';
interface PriceEditorProps {
  id: string;
  price: number;
  editedPrice: string;
  maxConsultationServiceFee: number;
  defaultExpectedPrice: number;
}
const StyledModal = styled(Modal)`
  padding: 2em;
`;
const StyledModalHeader = styled(ModalHeader)`
  text-align: left;
  padding: 0;
  margin-bottom: 1em;
`;
const StyledModalFooter = styled(ModalFooter)`
  justify-content: flex-end;
  padding: 1rem 0;
  padding-bottom: 0;
`;
const CartPage: React.FC = () => {
  const cart = useCart();
  const [priceEditorData, setPriceEditorData] = useState<PriceEditorProps>({
    id: '',
    price: 0,
    editedPrice: '',
    maxConsultationServiceFee: 0,
    defaultExpectedPrice: 0,
  });
  const [showPriceEditor, setShowPriceEditor] = useState(false);
  const priceEditorError =
    !priceEditorData.editedPrice ||
    priceEditorData.price > Number(priceEditorData.editedPrice) ||
    Number(priceEditorData.editedPrice) >
      priceEditorData.price + Number(priceEditorData.maxConsultationServiceFee);
  const doEditPrice = (
    id: string,
    price: number,
    defaultExpectedPrice: number,
    maxConsultationServiceFee: number,
  ) => {
    setShowPriceEditor(true);
    setPriceEditorData({
      id,
      price,
      maxConsultationServiceFee,
      editedPrice: price.toString(),
      defaultExpectedPrice,
    });
  };
  const doChangePrice = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPriceEditorData((prev: PriceEditorProps) => ({
      ...prev,
      editedPrice: event.target.value,
    }));
  };
  const confirmChangePrice = async () => {
    const editedPrice = Number(priceEditorData.editedPrice);
    if (!priceEditorError && editedPrice) {
      const selectedId = priceEditorData.id;
      const selectedLine = cart?.order?.orderLines.find(
        ({ id }) => id === selectedId,
      );
      await cart.onUpdateOrderLine(selectedId, {
        quantity: selectedLine.quantity,
        selected: selectedLine.isSelected,
        consultationServiceFee: editedPrice - priceEditorData.price,
      });
      setShowPriceEditor(false);
    }
  };
  return (
    <>
      <Cart
        cart={cart}
        cartLineList={
          <CartLineList
            cart={cart}
            sellerLines={cart?.order?.sellerLines}
            onEditPrice={doEditPrice}
            showQuantityError
            isAllowEditPrice={true}
          />
        }
      />
      <StyledModal
        size="sm"
        show={showPriceEditor}
        onHide={() => {
          setShowPriceEditor(false);
        }}
      >
        <StyledModalHeader>{t('Thay đổi giá sản phẩm')}</StyledModalHeader>
        <ConsultationServiceFee
          isShow={showPriceEditor}
          sellingPrice={priceEditorData.price}
          maxConsultationServiceFee={priceEditorData.maxConsultationServiceFee}
          onChangePrice={doChangePrice}
          defaultExpectedPrice={priceEditorData.defaultExpectedPrice}
        />
        <StyledModalFooter>
          <ModalAction>
            <DeclineButton
              onClick={() => {
                setShowPriceEditor(false);
              }}
              variant="normal"
            >
              {t('Hủy')}
            </DeclineButton>
            <AcceptButton
              disabled={priceEditorError}
              variant="primary"
              onClick={async () => {
                setShowPriceEditor(false);
                await confirmChangePrice();
              }}
            >
              {t('Xác nhận')}
            </AcceptButton>
          </ModalAction>
        </StyledModalFooter>
      </StyledModal>
    </>
  );
};
const AcceptButton = styled(Button)`
  margin-left: 8px;
  height: 36px;
  padding: 0 20px;
  min-width: 100px;
`;
const DeclineButton = styled(Button)`
  margin-right: 8px;
  height: 36px;
  padding: 0 20px;
  min-width: 100px;
  color: #434657;
`;
const ModalAction = styled.div`
  text-align: center;
`;
export default CartPage;
